module.exports = __webpack_public_path__ + "img/flecha_up.1592a40d.svg";